"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var Link_1 = __importDefault(require("shared/components/Link"));
var CommentMention = function (_a) {
    var _b = __read(_a.notifications, 1), notif = _b[0];
    return !notif.service ? null : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("strong", { children: [(0, end2end_1.getDisplayName)(notif.sourceUser), ' '] }), "mentioned you in a comment on", ' ', (0, jsx_runtime_1.jsx)(Link_1.default, __assign({ to: "/tools/".concat(notif.service.metaCategoryId, "/").concat(notif.service.slug) }, { children: notif.service.niceName || notif.service.name })), "."] }));
};
exports.default = CommentMention;
